export function trackMoengageEvents(event, options = {}) {
    (window as any).Moengage?.track_event(event)
}

export function updateMoengageParameters(name, phone_number, unique_user_id) {
    (window as any).Moengage?.add_user_name(name);
    (window as any).Moengage?.add_mobile(phone_number);
    (window as any).Moengage?.add_unique_user_id(unique_user_id);
}


export function moeAddUserAttribute(key, value) {
    (window as any).Moengage?.add_user_attribute(key, value)
}

export function getDeviceUuid() {
    return (window as any).Moengage?.device?.getUuid()
}

export function getPushToken() {
    return (window as any).Moengage?.device?.getPushToken()
}

export const MoengageEvents = {
    oms_order_started: 'oms_order_started',
    oms_order_placed: 'oms_order_placed',
    subsequent_order_success: 'subsequent_order_success',
    oms_chat_call: 'oms_chat_call',
    oms_pharmacy_call: 'oms_pharmacy_call', // not calling
    delivery_location_selected: 'delivery_location_selected',
    oms_delivery_address_select: 'oms_delivery_address_select',
    viewed_store_page: 'viewed_store_page', // not calling
    marked_favourite_store: 'marked_favourite_store', // not calling
    oms_order_cancelled: 'oms_order_cancelled',
    oms_chat_opened: 'oms_chat_opened',
    oms_order_delivered: 'oms_order_delivered',
    oms_no_pharmacy_found: 'oms_no_pharmacy_found',
    new_address_added: 'new_address_added',
    chat_msg_sent: 'chat_msg_sent',
    cart_created: 'cart_created',

    logged_in: 'logged_in',
    relogged_in: 'relogged_in',
    otp_submitted: 'otp_submitted',
    login_started: 'login_started',

    econsult_details: 'econsult_details',

    aayu_card_purchased: 'aayu_card_purchased',

    econsult_payment_cancelled: 'econsult_payment_cancelled',
    aayu_card_payment_cancelled: 'aayu_card_payment_cancelled',

    consultation_coupon_applied: 'consultation_coupon_applied',
    aayu_card_coupon_applied: 'aayu_card_coupon_applied'
}